<template>
  <div class="appear-setting" :style="{height: collapse ? '46px': oneRadius ? '176px' : '236px'}">
    <div class="appear-setting-header" @click="collapse = !collapse">
      <span>外观</span>
      <i class="icon icon-set-down" :style="{transform: collapse ? '' : 'rotate(180deg)'}"></i>
    </div>
    <div class="appear-setting-content">
      <div class="appear-setting-bg">
        <span>背景色</span>
        <div class="bg-content">
          <div 
            :style="{backgroundColor: bgColor || '#fff'}"
            @click="showColorPicker($event, { whichPart: 'appear_bgColor' });"
          ></div>
          <div class="cancel-color" @click="colorPickerInput ({hex: ''}, { type: 'appear_bgColor' })"></div>
        </div>
      </div>
      <div class="appear-setting-border">
        <span>边框</span>
        <div class="border-content">
          <div 
            :style="{backgroundColor: border.color}"
            @click="showColorPicker($event, { whichPart: 'appear_borderColor' });"
          ></div>
          <el-popover
            class="el-dropdown"
            placement="bottom"
            popper-class="stroke-width-dropdown"
            width="74"
            trigger="click"
          >
            <span class="el-dropdown-link" slot="reference">
              <span :class="[border.style, 'border-style']" style="width: 44px;height: 3px;"></span>
              <i class="icon-set-down-l"></i>
            </span>
            <div class="dropdown__options">
              <div
                class="dropdown__item"
                v-for="item in bStyele"
                :key="item"
                :class="{active: border.style === item}"
                @click="changeBorder(undefined, item, undefined)"
              >
                <span :class="[item, 'border-style']"></span>
              </div>
            </div>
          </el-popover>
          <el-popover
            class="el-dropdown-size"
            popper-class="stroke-width-dropdown"
            placement="bottom"
            width="48"
            trigger="click"
          >
            <span class="el-dropdown-link" slot="reference">
              <span>{{border.width}}</span>
              <i class="icon-set-down-l"></i>
            </span>
            <div class="dropdown__options"  :style="{width: '48px'}">
              <div
                class="dropdown__item"
                v-for="i in 11"
                :key="i"
                :class="{active: border.width === i-1}"
                @click="changeBorder(i-1, undefined, undefined);"
              >
                <span>{{i-1}}</span>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
      <div class="appear-setting-radius">
        <span>圆角</span>
        <div class="radius-content">
          <div class="radius-one">
            <input type="number"
              v-model="bRadius"
              :disabled="!oneRadius"
              @click.stop
              @keydown.stop="radiusKeyDown"
              @mousedown.stop
              @focus="inputFocus(4)"
              @blur="inputBlur()"
            >
            <el-tooltip
              effect="dark"
              placement="bottom"
              content="圆角"
            >
              <div class="select-one" :class="{'active': oneRadius}" @click="oneRadius=true">
                <span></span>
              </div>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              placement="bottom"
              content="独立圆角"
            >
              <div class="select-four" :class="{'active': !oneRadius}" @click="oneRadius=false;$analysis('base_setting_panel,click_senior_radius,基础设置面板_点击_高级圆角');">
                <i class="icon-set-radius"></i>
              </div>
            </el-tooltip>
          </div>
          <div class="radius-four" v-if="!oneRadius" @click.stop @keydown.stop="radiusKeyDown" @mousedown.stop>
            <div v-for="i in 4" :key="i">
              <input type="number" v-model="border.radius[i-1]" @focus="inputFocus(i-1)" @blur="inputBlur()">
              <i :class="['border-radius-'+i]"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    updateData: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      collapse: false,
      bgColor: '',
      border: {
        width: 0,
        style: 'solid',
        color: '#888888',
        radius: [0, 0, 0, 0]
      },
      bStyele: ['solid', 'dashed', 'dotted', 'double'],
      bRadius: 0,
      radiusIndex: -1,
      oneRadius: true,
      inputDom: null,
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
    ]),
  },
  watch: {
    'updateData'(val, oldVal) {
      this.initData();
    },
    'bRadius'(val, oldVal) {
      if(this.radiusIndex !== 4 || val == oldVal) return;
      this.bRadius = this.calcRadius(val)
      this.border.radius = [this.bRadius, this.bRadius, this.bRadius, this.bRadius];
      this.changeBorder()
    },
    'border.radius'(val, oldVal) {
      if(this.radiusIndex < 0 || this.radiusIndex > 3) return;
      this.border.radius[this.radiusIndex] = this.calcRadius(val[this.radiusIndex]);
      this.changeBorder();
    }
  },
  mounted() {
    this.initData();
    this.$bus.on('colorPickerInput.picker', this.colorPickerInput);
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
  },
  methods: {
    initData() {
      let s = this.SelectSprites_Msg[0];
      let border = s.border;
      this.oneRadius = true;
      this.radiusIndex = -1;
      this.bgColor = s.bgColor || '';
      if(!border) {
        this.border = {
          width: 0,
          style: 'solid',
          color: '#888888',
          radius: [0, 0, 0, 0]
        }
        this.bRadius = 0;
      } else {
        Object.assign(this.border, border);
        delete this.border.dom;
        this.border.radius = [].concat(border.radius);
        this.bRadius = this.border.radius[0];
        this.border.radius.forEach((item) => {
          if(item !== this.bRadius) this.oneRadius = false;
        })
      }
    },
    showColorPicker (e, { whichPart } = {}) {
      let rect = e.target.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        type: 1,
        posx : rect.left - 50,
        posy : rect.top + 30,
        whichPart,
        color: this.bgColor
      });
    },
    colorPickerInput(obj, { type }) {
      if(type === 'appear_bgColor') {
        let undoData = {
          scenesId: this.SelectScenes_Msg.id,
          data: {},
          reData: []
        }
        this.bgColor = obj.hex || '';
        undoData.data.hex = this.bgColor;
        for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
          let s = this.SelectSprites_Msg[i];
          undoData.reData.push({
            id: s.id,
            hex: s.bgColor
          })
          s.setBgColor(obj.hex);
        }
        eve("undo_redo", null, {type: 'bgColors', data: undoData})
      } else if (type === 'appear_borderColor') {
        this.changeBorder(undefined, undefined, obj.hex)
      }
    },
    changeBorder(width, style, color) {
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: null,
        reData: []
      }
      typeof width === 'number' && (this.border.width = width)
      style && (this.border.style = style)
      color && (this.border.color = color)
      let border = Object.assign({},this.border);
      border.radius = [].concat(this.border.radius);
      undoData.data = Object.assign({}, border);
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        let oldVal = s.border ? $.extend({}, s.border) : null;
        if(oldVal) delete oldVal.dom
        undoData.reData.push({
          id: s.id,
          border: oldVal
        })
        s.setBorder(border)
      }
      eve("undo_redo", null, {type: 'setBorders', data: undoData})
    },
    inputFocus(i) {
      this.radiusIndex = i;
    },
    inputBlur() {
      this.radiusIndex = -1;
    },
    calcRadius(n) {
      n = Math.round(n)
      if(n > 100) {
        n = 100;
      } else if(n < 0) {
        n = 0
      }
      return n;
    },
    radiusKeyDown(e) {
      if(e.keyCode === 38 || e.keyCode === 40) {
        this.$analysis({
          category: 'base_setting_panel',
          action: 'radius_key_updown',
          label: '基础设置面板_上下调整_圆角'
        })
      } else {
        this.$analysis({
          category: 'base_setting_panel',
          action: 'radius_keyenter',
          label: '基础设置面板_键盘输入_圆角'
        })
      }
    },
    _undoRedoHandle({type}) {
      if (type === 'bgColors' || type === 'setBorders') {
        this.initData();
      }
    }
  },
  beforeDestroy() {
    this.$bus.off('colorPickerInput.picker', this.colorPickerInput);
    this.$bus.off("undoRedoHandle", this._undoRedoHandle);
  }
}
</script>

<style lang="scss" scoped>
.appear-setting {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.appear-setting-header {
  display: flex;
  height: 46px;
  line-height: 46px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;

  i {
    width: 10px;
    height: 6px;
    margin-right: 10px;
    transition: all 0.3s;
  }
}
.appear-setting-bg, .appear-setting-border, .appear-setting-radius {
  margin-bottom: 15px;
  display: flex;
  justify-content:space-between;
  align-items: center;
  height: 32px;

  > span {
    width: 50px;
    text-align: left;
  }

  > div {
    width: 175px;
  }
}
.appear-setting-bg {
  justify-self: start;
  margin-bottom: 10px;

  .bg-content {
    display: flex;

    div:not(.cancel-color) {
      width: 36px;
      height: 24px;
      border-radius: 4px;
      background-color: #5779fa;
      cursor: pointer;
      border: 1px solid #D9DDE9;
    }
  }
}
.appear-setting-border {
  .border-content {
    display: flex;
    justify-content:space-between;
    align-items: center;

    div:first-child {
      width: 36px;
      height: 24px;
      border-radius: 4px;
      background-color: #5779fa;
      cursor: pointer;
      border: 1px solid #D9DDE9;
    }
  }
}
.cancel-color {
  width: 35px;
  height: 24px;
  margin-left: 10px;
  border: 1px solid #D9DDE9;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background-color: #F6F7FC;
  }

  &::before {
    content: '';
    position: relative;
    top: 10px;
    left: 7px;
    display: block;
    transform: rotate(-45deg);
    width: 20px;
    height: 1px;
    background-color: #FF292B;
  }
}

.el-dropdown, .el-dropdown-size {
  width: 74px;
  height: 24px;
  line-height: 24px;
  border: solid 1px #D9DDE9;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  padding-left: 6px;
  padding-right: 6px;
}
.el-dropdown-size {
  width: 48px;
}
.el-dropdown-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
}

.border-style {
  display: inline-block;
  width: 40px;
  height: 5px;
  margin-bottom: 2px;
  border-bottom: 3px solid #9692a9;
}
.border-style.dashed {
  border-bottom-style: dashed;
}
.border-style.dotted {
  border-bottom-style: dotted;
}
.border-style.double {
  border-bottom-style: double;
}
.border-width-item {
  width: 20px;
  background-color: #9692a9;
}

.dropdown {
  position: relative;
  &__select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80px;
    height: 24px;
    line-height: 24px;
    border: solid 1px #D9DDE9;
    margin-left: 15px;
    cursor: pointer;
    text-align: left;
    padding-left: 12px;
    padding-right: 12px;
  }
  &__options {
    // position: absolute;
    z-index: 1;
    top: 120%;
    left: 15px;
    width: 74px;
    border: solid 1px #D9DDE9;
  }
  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 24px;
    line-height: 24px;
    background-color: #fff;
    cursor: pointer;
    padding: 0 3px;

    & > span:nth-child(1) {
      width: 25px;
      text-align: center;
      color: #9692a9;
    }
    &:hover, &.active {
      background-color: #D9DDE9;
    }
  }
}

.appear-setting-radius {
  align-items: flex-start;
  height: inherit;

  > span {
    margin-top: 4px;
  }
}
.radius-one {
  display: flex;
  justify-content: space-between;

  input {
    width: 84px;
    height: 24px;
    border: 1px solid #D9DDE9;
    text-align: center;
  }
  input:disabled {
    color: #D9DDE9;
    background-color: #ffffff;
  }
  .select-one, .select-four {
    width: 24px;
    height: 24px;
    border: 1px solid #D9DDE9;
    border-radius: 4px;
    background-color: #fff;
    margin-left: 5px;
    cursor: pointer;

    &.active {
      border-color: #5778FD;
      background-color: #F6F7FC;
      span {
        border-color: #5778FD;
      }
    }

    span {
      display: block;
      border: 1px solid #737596;
      margin: 4px;
      border-radius: 4px;
      width: 14px;
      height: 14px;
      background-color: #fff;
    }
  }
}
.select-four i {
  width: 100%;
  height: 100%;
  background-size: 14px;
  background-position: center;
}
.radius-four {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  >div {
    position: relative;
  }

  input {
    width: 84px;
    height: 24px;
    text-align: center;
    border: 1px solid #D9DDE9;
    margin: 6px 0 0 0;
    border-radius: 4px;
    background-color: #F6F7FC;
  }
  
  input:focus {
    border-color: #5778FD;
  }

  i {
    position: absolute;
    top: 12px;
    left: 8px;
    display: block;
    width: 14px;
    height: 14px;
    border: 1px solid #5778FD;
    border-radius: 5px;
  }
  i.border-radius-1 {
    clip-path: polygon(70% 0, 0 70%, 0 0)
  }
  i.border-radius-2 {
    left: 58px;
    clip-path: polygon(30% 0, 100% 0, 100% 70%)
  }
  i.border-radius-3 {
    clip-path: polygon(0 30%, 70% 100%, 0 100%)
  }
  i.border-radius-4 {
    left: 58px;
    clip-path: polygon(100% 30%, 100% 100%, 30% 100%)
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/appearSetting.vue